import { render, staticRenderFns } from "./ambiguous_ref_modal.vue?vue&type=template&id=553f57e6"
import script from "./ambiguous_ref_modal.vue?vue&type=script&lang=js"
export * from "./ambiguous_ref_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports